"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = exports.sizeStyles = exports.input = exports.icon = exports.container = void 0;

var react_1 = require("@emotion/react");

exports.container = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: var(--gray-300);\n  transition: background 0.35s var(--motion-easing-basic);\n"])));
exports.icon = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin: 2px;\n  background-color: var(--white);\n  transition: left 0.25s var(--motion-easing-basic);\n"])));
exports.input = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n  left: 0;\n  top: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n\n  cursor: pointer;\n"])));
exports.sizeStyles = {
  sm: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 36px;\n    height: 20px;\n    border-radius: 20px;\n\n    & > span {\n      width: 16px;\n      height: 16px;\n      border-radius: 16px;\n    }\n  "]))),
  md: react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 56px;\n    height: 32px;\n    border-radius: 32px;\n    & > span {\n      width: 28px;\n      height: 28px;\n      border-radius: 28px;\n    }\n  "])))
};
var activeStyles = {
  sm: react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    left: calc(100% - 20px);\n  "]))),
  md: react_1.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    left: calc(100% - 32px);\n  "])))
};

var active = function active(size) {
  return react_1.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background-color: var(--blue-400);\n  & > span {\n    ", "\n  }\n"])), activeStyles[size]);
};

exports.active = active;